Ext.define('SA.model.map.PaperSize', {
    extend: 'Ext.data.Model',

    fields: ['height', 'width'],

    getHeight() {
        return this.get('height');
    },

    getWidth() {
        return this.get('width');
    },

    getAspectRatio() {
        return this.getHeight() / this.getWidth();
    }
}, function(cls) {
    cls.sizes = {
        Legal: new cls({width: 8.5 * 300, height: 14 * 300}),
        Letter: new cls({width: 8.5 * 300, height: 11 * 300}),
        Tabloid: new cls({width: 11 * 300, height: 17 * 300})
    };
});